'use client'
import Link from 'next/link'
import React from "react";
import {useTranslation} from "@/lib/hooks/useTranslation";

export default function NotFound() {

    const t = useTranslation()

    return (

        <div className="container">
            <div className="row">
                <h1 className="h1 mt-5">{t('page.not-found.title')}</h1>
            </div>
            <div className="row">
                <div className="col-12">
                    <Link href="/" className="btn btn-primary btn-back has-link mt-3">{t('page.not-found.back-to-home')}</Link>
                </div>
            </div>

        </div>

    )
}
